import { aptApiSlice } from '.';
import { URLS } from '../../../constants';

export const clarityNav = aptApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getUserDetails: builder.mutation({
            query: () => ({
                url: URLS.USER_DETAILS,
                method: 'GET',
            })
        }),
        //azure
        logoutApplication: builder.mutation({
            query: () => ({
                url: URLS.LOGOUT_URL,
                method: 'POST',
                body: { app_type: "Clarity" },
            }),
        }),
        tokenValidation: builder.mutation({
            query: (token) => ({
                url: URLS.TOKEN_VALIDATION,
                method: 'POST',
                body: {token: token},
            })
        }),
        refreshTokenFun: builder.mutation({
            query: (refreshToken) => ({
                url: URLS.REFRESH_TOKEN,
                method: 'POST',
                body:{ refresh_token: refreshToken},
            })
        }),
        //azure
        //sso
        getUsersList: builder.mutation({
            query: ({ search }) => {
                const body = {};
                if (search) {
                    body["search"] = search;
                }
                return {
                    url: URLS.USER_LIST,
                    method: 'POST',
                    body,
                };
            },
        }),
        //sso
        projectList: builder.query({
            query: ({ search, projectType, limit = 10, page }) => {
                const params = {
                    limit,
                    page,
                };
        
                if (search) {
                    params.search = search;
                }
        
                if (projectType) {
                    params.projectType = projectType;
                }
        
                return {
                    url: URLS.PROJECT_LIST,
                    params,
                };
            },
        }),
        
        
        lockProject: builder.mutation({
            query: ({ projectId }) => ({
                url: URLS.LOCK_PROJECT(projectId),
                method: 'POST',
              
            })
        }),
        unlockProject: builder.mutation({
            query: ({ projectId }) => ({
                url: URLS.UNLOCK_PROJECT(projectId),
                method: 'POST',
               
            })
        }),
        getAutherizedUser: builder.mutation({
            query: ({ projectId }) => ({
                url: URLS.GET_AUTHORIZED_USER(projectId),
                method: 'POST',
            }),
        }),
        updateProjectCollaborator: builder.mutation({
            query: ({ projectId, data }) => (
                {
                    url: URLS.UPDATE_PROJECT_COLLABORATOR(projectId),
                    method: 'PUT',
                    body: data,
                }
            ),
        }),
        ArchiveProject: builder.mutation({
            query: (data) => ({
                url: URLS.ARCHIVE_PROJECT,
                method: 'POST',
                body: data,
            }),
        }),
        deleteProject: builder.mutation({
            query: (data) => ({
                url: URLS.DELETE_PROJECT,
                method: 'DELETE',
                body: data,
            }),
        }),
       
        projectNameValidation: builder.mutation({
            query: (data) => (
                {
                    url: URLS.PROJECT_NAME_VALIDATION,
                    method: 'POST',
                    body: data,
                }
            ),
        }),
       
        createProject: builder.mutation({
            query: (data) => ({
                url: URLS.CREATE_PROJECT,
                method: 'POST',
                body: data
            }),
        }),
        updateProject: builder.mutation({
            query: ({ data, projectId }) => ({
                url: URLS.UPDATE_PROJECT(projectId),
                method: 'PATCH',
                body: data
            }),
        }),
        getProjectDataFromProjectId: builder.query({
            query: (projectId) => ({
                url: URLS.GET_PROJECT_DATA_FROM_PROJECT_ID(projectId),
            }),
        }),
        getlookupdata: builder.query({
            query: () => ({
                url: URLS.GET_LOOKUP_DATA,
            }),
        }),
        getMvocDataFromProjectId: builder.query({
            query: (projectId) => ({
                url: URLS.GET_MVOC_DATA_FROM_PROJECT_ID(projectId),
            }),
        }),
        createMVOC: builder.mutation({
            query: ({project_id,data}) => ({
                url: URLS.CREATE_MVOC(project_id),
                method: 'POST',
                body: data
            }),
        }),
        SaveWaveAndPrompt: builder.mutation({
            query: ({project_id,data}) => ({
                url: URLS.SAVE_WAVE_PROMPT(project_id),
                method: 'POST',
                body: data
            }),
        }),
        uploadFileChunk: builder.mutation({
            query: (formData) => ({
              url: URLS.UPLOAD, 
              method: 'POST',
              headers: {
                'Content-Type': 'multipart/form-data;'
              },
              body: formData,
              formData: true,
              meta: { isFormData: true },
            }),
        }),
        sseEvent: builder.query({
            query: (projectId) => ({
                url: URLS.SSE_EVENT(projectId),
            }),
        }),
        FetchChatGpt: builder.mutation({
            query: ({project_id,wave_unified_id,selectedUnifiedId}) => {
                const unified_id = wave_unified_id ?? selectedUnifiedId;
                return {

                    url: URLS.FETCH_CHAT_GPT(project_id,unified_id),
                }
                // body: payload
            },
        }),
        acknowlegeChatGpt: builder.mutation({
            query: ({project_id,data}) => ({
                url: URLS.ACKNOWLEDGE_CHAT_GPT(project_id),
                method: 'POST',
                body: data
            }),
        }),
        ProjectPrompts: builder.mutation({
            query: ({project_id}) => ({
                url: URLS.PROJECT_PROMPTS(project_id),
                method: 'GET',
                
            }),
        }),
        SaveProjectPrompts: builder.mutation({
            query: ({project_id,data}) => ({
                url: URLS.SAVE_PROJECT_PROMPTS(project_id),
                method: 'POST',
                body: data
            }),
        }),
        getMvocMetaData: builder.mutation({
            query: (projectId) => ({
                url: URLS.GET_MVOC_META_DATA(projectId),
                method: 'GET',
            }),
        }),
        downloadBlobFile: builder.mutation({
            query: (file_path) => ({
                url: URLS.DOWNLOAD_BLOB_FILE,
                method: 'GET',
                params: {file_path},
            }),
        }),
        fileInactive: builder.mutation({
            query: ({ file_id, project_id }) => {
                console.log("Cancelling file upload with ID:", file_id);
                console.log("Project ID:", project_id);
                return {
                    url: URLS.FILE_INACTIVE(file_id, project_id),
                    method: 'POST',
                };
            },
        }),
        getLongitudinalWaveData: builder.mutation({
            query: ({project_id, params}) => ({
                url: URLS.GET_LONGITUDINAL_WAVE_DATA(project_id),
                method: 'GET',
                params: params
            }),
        }),
        getLongitudinalData: builder.mutation({
            query: ({projectId, data}) => ({
                url: URLS.GET_LONGITUDINAL__DATA(projectId),
                method: 'POST',
                body: data
            }),
        }),
        uploadFileServiceApi: builder.mutation({
            query: ({ formData, body, project_id, headers }) => {

                console.log(formData, body, project_id, headers, "lskqjcuigdy")

                // Append body fields to FormData
                Object.keys(body || {}).forEach((key) => {
                    formData.append(key, body[key]);
                });

                return {
                    url: `/file/upload/public/${project_id}`,
                    method: 'POST',
                    body: formData,
                    formData: true,
                    headers: {
                        'file-size': headers?.file_size,
                        'file-name': headers?.file_name,
                        'actual-file-name': headers?.actual_file_name,
                        'chunk-index': headers?.chunk_index,
                        'total-chunks': headers?.total_chunks,
                    },
                };

            },
        }),
        DownloadFileServiceApi: builder.mutation({
            query: ({ project_id, filePath }) => ({
              url: `/blob/public/download/${project_id}?file_path=${encodeURIComponent(filePath)}`,
              method: 'GET',
              responseHandler: async (response) => await response.blob(),
            }),
          }),


    }),
    overrideExisting: true,
});

